/*
 * This code is the intellectual property of Bulb Inc. and other software publishers;
 * it may not be altered, copied or disclosed without prior written approval.
 * Copyright 2022, Bulb Inc.  For more information, please email contact@hellobulb.com.
 */

import { Component, Input, ViewChild } from '@angular/core';
import { SvgIconRegistry } from '@ngneat/svg-icon';
import { faSearchIcon } from 'IconLibrary/fontawesome/regular/search';
import { TranslocoService } from '@jsverse/transloco';
import { UppyComponentEvent, UppyComponentEventStatus, UppyComponentEventType } from '../types';
import { UppyDashboardComponent } from '../uppy-dashboard/uppy-dashboard.component';

@Component({
  selector: 'bulb-asset-library-upload-button',
  templateUrl: './asset-library-upload-button.component.html',
  styleUrls: ['./asset-library-upload-button.component.scss'],
  standalone: false,
})
export class AssetLibraryUploadButtonComponent {

  /**
   * ViewChild of the Uppy Dashboard to get access to the public functions.
   */
  @ViewChild('uppyDashboard') uppyDashboard: UppyDashboardComponent;

  /**
   * Callback function to handle the onComplete event.
   */
  @Input() onCompleteCallback: Function;

  /**
   * Optional input of the folder id the asset should be uploaded to.
   */
  @Input() folderId?: string;

  /**
   * Default constructor.
   * @param iconRegistry sets up the icon registry for the Plus Icon.
   * @param transloco translating service.
   */
  constructor(
    private iconRegistry: SvgIconRegistry,
    private transloco: TranslocoService,
  ) {
    this.iconRegistry.register([faSearchIcon]);
  }

  /**
   * Opens the Uppy Dashboard modal. No reason to do anything with the promise it returns here.
   */
  public openUppyDashboard() {
    this.uppyDashboard.open();
  }

  /**
   * Handles events from the Uppy Dashboard.
   * Only handles onComplete since you can only upload one file at this time so onSuccess is redundant,
   * and errors are handled internally in the component.
   *
   * @param event that was emitted from the dashboard.
a   */
  handleUppyEvents(event: UppyComponentEvent) {
    if (event.type === UppyComponentEventType.ON_COMPLETE
      && event.status === UppyComponentEventStatus.SUCCESS) {
      // This waits for the uppy modal to be fully closed before calling.
      setTimeout(() => {
        this.onCompleteCallback();
      }, 550);
    }
  }
}
